export enum phoneModalTypes {
  SET_PHONE_MODAL_DISMISSED = 'SET_PHONE_MODAL_DISMISSED',
  RESET_PHONE_MODAL = 'RESET_PHONE_MODAL',
  /** Triggers a single deduped GET /user/phone-prompt in the user saga (takeLeading). */
  PHONE_PROMPT_ENSURE = 'PHONE_PROMPT_ENSURE',
  /** Result of phone-prompt API; shared by location pages and add-phone modal. */
  PHONE_PROMPT_FETCH_SUCCESS = 'PHONE_PROMPT_FETCH_SUCCESS',
}

